module.exports = {
	"name": "PS4 Firefox OSX",
	"supported": [
		{
			"id": "54c-5c4-Wireless Controller",
			"os": "Mac OS X",
			"browser": "Firefox"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"right stick x": {
			"index": 2
		},
		"right stick y": {
			"index": 5
		},
		"dpad x": {
			"index": 6
		},
		"dpad y": {
			"index": 7
		}
	},
	"buttons": {
		"a": {
			"index": 0
		},
		"b": {
			"index": 1
		},
		"x": {
			"index": 2
		},
		"y": {
			"index": 3
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"dpad left": {
			"index": 16
		},
		"dpad right": {
			"index": 17
		},
		"dpad up": {
			"index": 14
		},
		"dpad down": {
			"index": 15
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"back": {
			"index": 8
		},
		"home": {
			"index": 13
		},
		"start": {
			"index": 9
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left stick": {
			"index": 10
		},
		"right stick": {
			"index": 11
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"right stick up": {
			"axis": 5,
			"direction": -1
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		},
		"right stick down": {
			"axis": 5,
			"direction": 1
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/ps4-ff-osx.json
// module id = 213
// module chunks = 0